import { request } from '@/request/request';
import { parameterChange } from '@/utils';

const prefix = `${process.env.VUE_APP_OU_PREFIX}/clinic_product`;

// 门诊产品库与咨询线索
export default {
  clinicProductPageList(data) {
    return request({ url: `${prefix}/productPageList?${parameterChange(data)}`, method: 'get', data });
  },
  clinicProductDetail(data) {
    return request({ url: `${prefix}/productDetail?${parameterChange(data)}`, method: 'get', data });
  },
  clinicProductCategoryList() {
    return request({ url: `${prefix}/categoryList`, method: 'get' });
  },
  clinicProductAdd(data) {
    return request({ url: `${prefix}/productAdd`, method: 'post', data });
  },
  clinicProductUpdate(data) {
    return request({ url: `${prefix}/productUpdate`, method: 'post', data });
  },
  clinicProductDelete(data) {
    return request({ url: `${prefix}/productDelete`, method: 'post', data });
  },
  clinicConsultPageList(data) {
    return request({ url: `${prefix}/consultPageList?${parameterChange(data)}`, method: 'get', data });
  },
  clinicConsultUpdate(data) {
    return request({ url: `${prefix}/consultUpdate`, method: 'post', data });
  },
};
